<template>
    <div class="learnmore -mt-36">
    <div class="h-16 w-42 border-2 border-neutral-800 rounded-2xl bg-black">
        <div class="flex items-center justify-center">
        <p class="text-small text-white font-mono p-4 ">Learn More 
        <img class="h-6 inline-block align-middle" src="../assets/finger_pointing_down.png">
        </p>
       </div>   
    </div>
    </div>
</template>

<script>
  export default {
    name: 'LearnMore',
  };
</script>

<style scoped>
.learnmore {
  position: relative; 
  z-index: 1;
}
</style>


  